import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _35a8ed18 = () => interopDefault(import('../pages/banner_home.vue' /* webpackChunkName: "pages/banner_home" */))
const _508d2469 = () => interopDefault(import('../pages/cards.vue' /* webpackChunkName: "pages/cards" */))
const _e08117ec = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _4227c430 = () => interopDefault(import('../pages/category.vue' /* webpackChunkName: "pages/category" */))
const _1cb34a30 = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _27717229 = () => interopDefault(import('../pages/cmsPreview.vue' /* webpackChunkName: "pages/cmsPreview" */))
const _1aef7cda = () => interopDefault(import('../pages/coupons.vue' /* webpackChunkName: "pages/coupons" */))
const _344372e0 = () => interopDefault(import('../pages/dshop.vue' /* webpackChunkName: "pages/dshop" */))
const _2deb8b52 = () => interopDefault(import('../pages/order_details.vue' /* webpackChunkName: "pages/order_details" */))
const _8dd9924e = () => interopDefault(import('../pages/order_list.vue' /* webpackChunkName: "pages/order_list" */))
const _88a70040 = () => interopDefault(import('../pages/payment_result.vue' /* webpackChunkName: "pages/payment_result" */))
const _78571164 = () => interopDefault(import('../pages/pending_payment.vue' /* webpackChunkName: "pages/pending_payment" */))
const _6f7de986 = () => interopDefault(import('../pages/productDetails.vue' /* webpackChunkName: "pages/productDetails" */))
const _03a5f93e = () => interopDefault(import('../pages/receipt.vue' /* webpackChunkName: "pages/receipt" */))
const _3d268e12 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _58df4b71 = () => interopDefault(import('../pages/similar.vue' /* webpackChunkName: "pages/similar" */))
const _6966f084 = () => interopDefault(import('../pages/store_locator.vue' /* webpackChunkName: "pages/store_locator" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/banner_home",
    component: _35a8ed18,
    name: "banner_home"
  }, {
    path: "/cards",
    component: _508d2469,
    name: "cards"
  }, {
    path: "/cart",
    component: _e08117ec,
    name: "cart"
  }, {
    path: "/category",
    component: _4227c430,
    name: "category"
  }, {
    path: "/checkout",
    component: _1cb34a30,
    name: "checkout"
  }, {
    path: "/cmsPreview",
    component: _27717229,
    name: "cmsPreview"
  }, {
    path: "/coupons",
    component: _1aef7cda,
    name: "coupons"
  }, {
    path: "/dshop",
    component: _344372e0,
    name: "dshop"
  }, {
    path: "/order_details",
    component: _2deb8b52,
    name: "order_details"
  }, {
    path: "/order_list",
    component: _8dd9924e,
    name: "order_list"
  }, {
    path: "/payment_result",
    component: _88a70040,
    name: "payment_result"
  }, {
    path: "/pending_payment",
    component: _78571164,
    name: "pending_payment"
  }, {
    path: "/productDetails",
    component: _6f7de986,
    name: "productDetails"
  }, {
    path: "/receipt",
    component: _03a5f93e,
    name: "receipt"
  }, {
    path: "/search",
    component: _3d268e12,
    name: "search"
  }, {
    path: "/similar",
    component: _58df4b71,
    name: "similar"
  }, {
    path: "/store_locator",
    component: _6966f084,
    name: "store_locator"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/category/:categoryId/:page(\\d+)?.html",
    component: _4227c430,
    name: "category_sku_page"
  }, {
    path: "/d/:id.html",
    component: _344372e0,
    name: "dshop_id"
  }, {
    path: "/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "pdp_title_i_sku"
  }, {
    path: "/wellcome/banner_home",
    component: _35a8ed18,
    name: "wellcome_banner_home"
  }, {
    path: "/zh-hant/wellcome/banner_home",
    component: _35a8ed18,
    name: "zh-hant_wellcome_banner_home"
  }, {
    path: "/zh-hant/banner_home",
    component: _35a8ed18,
    name: "zh-hant_banner_home"
  }, {
    path: "/en/wellcome/banner_home",
    component: _35a8ed18,
    name: "en_wellcome_banner_home"
  }, {
    path: "/en/banner_home",
    component: _35a8ed18,
    name: "en_banner_home"
  }, {
    path: "/wellcome/cards",
    component: _508d2469,
    name: "wellcome_cards"
  }, {
    path: "/zh-hant/wellcome/cards",
    component: _508d2469,
    name: "zh-hant_wellcome_cards"
  }, {
    path: "/zh-hant/cards",
    component: _508d2469,
    name: "zh-hant_cards"
  }, {
    path: "/en/wellcome/cards",
    component: _508d2469,
    name: "en_wellcome_cards"
  }, {
    path: "/en/cards",
    component: _508d2469,
    name: "en_cards"
  }, {
    path: "/wellcome/cart",
    component: _e08117ec,
    name: "wellcome_cart"
  }, {
    path: "/zh-hant/wellcome/cart",
    component: _e08117ec,
    name: "zh-hant_wellcome_cart"
  }, {
    path: "/zh-hant/cart",
    component: _e08117ec,
    name: "zh-hant_cart"
  }, {
    path: "/en/wellcome/cart",
    component: _e08117ec,
    name: "en_wellcome_cart"
  }, {
    path: "/en/cart",
    component: _e08117ec,
    name: "en_cart"
  }, {
    path: "/wellcome/category",
    component: _4227c430,
    name: "wellcome_category"
  }, {
    path: "/zh-hant/wellcome/category",
    component: _4227c430,
    name: "zh-hant_wellcome_category"
  }, {
    path: "/zh-hant/category",
    component: _4227c430,
    name: "zh-hant_category"
  }, {
    path: "/en/wellcome/category",
    component: _4227c430,
    name: "en_wellcome_category"
  }, {
    path: "/en/category",
    component: _4227c430,
    name: "en_category"
  }, {
    path: "/wellcome/checkout",
    component: _1cb34a30,
    name: "wellcome_checkout"
  }, {
    path: "/zh-hant/wellcome/checkout",
    component: _1cb34a30,
    name: "zh-hant_wellcome_checkout"
  }, {
    path: "/zh-hant/checkout",
    component: _1cb34a30,
    name: "zh-hant_checkout"
  }, {
    path: "/en/wellcome/checkout",
    component: _1cb34a30,
    name: "en_wellcome_checkout"
  }, {
    path: "/en/checkout",
    component: _1cb34a30,
    name: "en_checkout"
  }, {
    path: "/wellcome/cmsPreview",
    component: _27717229,
    name: "wellcome_cmsPreview"
  }, {
    path: "/zh-hant/wellcome/cmsPreview",
    component: _27717229,
    name: "zh-hant_wellcome_cmsPreview"
  }, {
    path: "/zh-hant/cmsPreview",
    component: _27717229,
    name: "zh-hant_cmsPreview"
  }, {
    path: "/en/wellcome/cmsPreview",
    component: _27717229,
    name: "en_wellcome_cmsPreview"
  }, {
    path: "/en/cmsPreview",
    component: _27717229,
    name: "en_cmsPreview"
  }, {
    path: "/wellcome/coupons",
    component: _1aef7cda,
    name: "wellcome_coupons"
  }, {
    path: "/zh-hant/wellcome/coupons",
    component: _1aef7cda,
    name: "zh-hant_wellcome_coupons"
  }, {
    path: "/zh-hant/coupons",
    component: _1aef7cda,
    name: "zh-hant_coupons"
  }, {
    path: "/en/wellcome/coupons",
    component: _1aef7cda,
    name: "en_wellcome_coupons"
  }, {
    path: "/en/coupons",
    component: _1aef7cda,
    name: "en_coupons"
  }, {
    path: "/wellcome/dshop",
    component: _344372e0,
    name: "wellcome_dshop"
  }, {
    path: "/zh-hant/wellcome/dshop",
    component: _344372e0,
    name: "zh-hant_wellcome_dshop"
  }, {
    path: "/zh-hant/dshop",
    component: _344372e0,
    name: "zh-hant_dshop"
  }, {
    path: "/en/wellcome/dshop",
    component: _344372e0,
    name: "en_wellcome_dshop"
  }, {
    path: "/en/dshop",
    component: _344372e0,
    name: "en_dshop"
  }, {
    path: "/wellcome/order_details",
    component: _2deb8b52,
    name: "wellcome_order_details"
  }, {
    path: "/zh-hant/wellcome/order_details",
    component: _2deb8b52,
    name: "zh-hant_wellcome_order_details"
  }, {
    path: "/zh-hant/order_details",
    component: _2deb8b52,
    name: "zh-hant_order_details"
  }, {
    path: "/en/wellcome/order_details",
    component: _2deb8b52,
    name: "en_wellcome_order_details"
  }, {
    path: "/en/order_details",
    component: _2deb8b52,
    name: "en_order_details"
  }, {
    path: "/wellcome/order_list",
    component: _8dd9924e,
    name: "wellcome_order_list"
  }, {
    path: "/zh-hant/wellcome/order_list",
    component: _8dd9924e,
    name: "zh-hant_wellcome_order_list"
  }, {
    path: "/zh-hant/order_list",
    component: _8dd9924e,
    name: "zh-hant_order_list"
  }, {
    path: "/en/wellcome/order_list",
    component: _8dd9924e,
    name: "en_wellcome_order_list"
  }, {
    path: "/en/order_list",
    component: _8dd9924e,
    name: "en_order_list"
  }, {
    path: "/wellcome/payment_result",
    component: _88a70040,
    name: "wellcome_payment_result"
  }, {
    path: "/zh-hant/wellcome/payment_result",
    component: _88a70040,
    name: "zh-hant_wellcome_payment_result"
  }, {
    path: "/zh-hant/payment_result",
    component: _88a70040,
    name: "zh-hant_payment_result"
  }, {
    path: "/en/wellcome/payment_result",
    component: _88a70040,
    name: "en_wellcome_payment_result"
  }, {
    path: "/en/payment_result",
    component: _88a70040,
    name: "en_payment_result"
  }, {
    path: "/wellcome/pending_payment",
    component: _78571164,
    name: "wellcome_pending_payment"
  }, {
    path: "/zh-hant/wellcome/pending_payment",
    component: _78571164,
    name: "zh-hant_wellcome_pending_payment"
  }, {
    path: "/zh-hant/pending_payment",
    component: _78571164,
    name: "zh-hant_pending_payment"
  }, {
    path: "/en/wellcome/pending_payment",
    component: _78571164,
    name: "en_wellcome_pending_payment"
  }, {
    path: "/en/pending_payment",
    component: _78571164,
    name: "en_pending_payment"
  }, {
    path: "/wellcome/productDetails",
    component: _6f7de986,
    name: "wellcome_productDetails"
  }, {
    path: "/zh-hant/wellcome/productDetails",
    component: _6f7de986,
    name: "zh-hant_wellcome_productDetails"
  }, {
    path: "/zh-hant/productDetails",
    component: _6f7de986,
    name: "zh-hant_productDetails"
  }, {
    path: "/en/wellcome/productDetails",
    component: _6f7de986,
    name: "en_wellcome_productDetails"
  }, {
    path: "/en/productDetails",
    component: _6f7de986,
    name: "en_productDetails"
  }, {
    path: "/wellcome/receipt",
    component: _03a5f93e,
    name: "wellcome_receipt"
  }, {
    path: "/zh-hant/wellcome/receipt",
    component: _03a5f93e,
    name: "zh-hant_wellcome_receipt"
  }, {
    path: "/zh-hant/receipt",
    component: _03a5f93e,
    name: "zh-hant_receipt"
  }, {
    path: "/en/wellcome/receipt",
    component: _03a5f93e,
    name: "en_wellcome_receipt"
  }, {
    path: "/en/receipt",
    component: _03a5f93e,
    name: "en_receipt"
  }, {
    path: "/wellcome/search",
    component: _3d268e12,
    name: "wellcome_search"
  }, {
    path: "/zh-hant/wellcome/search",
    component: _3d268e12,
    name: "zh-hant_wellcome_search"
  }, {
    path: "/zh-hant/search",
    component: _3d268e12,
    name: "zh-hant_search"
  }, {
    path: "/en/wellcome/search",
    component: _3d268e12,
    name: "en_wellcome_search"
  }, {
    path: "/en/search",
    component: _3d268e12,
    name: "en_search"
  }, {
    path: "/wellcome/similar",
    component: _58df4b71,
    name: "wellcome_similar"
  }, {
    path: "/zh-hant/wellcome/similar",
    component: _58df4b71,
    name: "zh-hant_wellcome_similar"
  }, {
    path: "/zh-hant/similar",
    component: _58df4b71,
    name: "zh-hant_similar"
  }, {
    path: "/en/wellcome/similar",
    component: _58df4b71,
    name: "en_wellcome_similar"
  }, {
    path: "/en/similar",
    component: _58df4b71,
    name: "en_similar"
  }, {
    path: "/wellcome/store_locator",
    component: _6966f084,
    name: "wellcome_store_locator"
  }, {
    path: "/zh-hant/wellcome/store_locator",
    component: _6966f084,
    name: "zh-hant_wellcome_store_locator"
  }, {
    path: "/zh-hant/store_locator",
    component: _6966f084,
    name: "zh-hant_store_locator"
  }, {
    path: "/en/wellcome/store_locator",
    component: _6966f084,
    name: "en_wellcome_store_locator"
  }, {
    path: "/en/store_locator",
    component: _6966f084,
    name: "en_store_locator"
  }, {
    path: "/wellcome",
    component: _2dfb1658,
    name: "wellcome"
  }, {
    path: "/zh-hant",
    component: _2dfb1658,
    name: "zh-hant"
  }, {
    path: "/en",
    component: _2dfb1658,
    name: "en"
  }, {
    path: "/wellcome/category/:categoryId/:page(\\d+)?.html",
    component: _4227c430,
    name: "wellcome_category_sku_page"
  }, {
    path: "/zh-hant/wellcome/category/:categoryId/:page(\\d+)?.html",
    component: _4227c430,
    name: "zh-hant_wellcome_category_sku_page"
  }, {
    path: "/zh-hant/category/:categoryId/:page(\\d+)?.html",
    component: _4227c430,
    name: "zh-hant_category_sku_page"
  }, {
    path: "/en/wellcome/category/:categoryId/:page(\\d+)?.html",
    component: _4227c430,
    name: "en_wellcome_category_sku_page"
  }, {
    path: "/en/category/:categoryId/:page(\\d+)?.html",
    component: _4227c430,
    name: "en_category_sku_page"
  }, {
    path: "/wellcome/d/:id.html",
    component: _344372e0,
    name: "wellcome_dshop_id"
  }, {
    path: "/zh-hant/wellcome/d/:id.html",
    component: _344372e0,
    name: "zh-hant_wellcome_dshop_id"
  }, {
    path: "/zh-hant/d/:id.html",
    component: _344372e0,
    name: "zh-hant_dshop_id"
  }, {
    path: "/en/wellcome/d/:id.html",
    component: _344372e0,
    name: "en_wellcome_dshop_id"
  }, {
    path: "/en/d/:id.html",
    component: _344372e0,
    name: "en_dshop_id"
  }, {
    path: "/wellcome/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "wellcome_pdp_title_i_sku"
  }, {
    path: "/zh-hant/wellcome/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "zh-hant_wellcome_pdp_title_i_sku"
  }, {
    path: "/zh-hant/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "zh-hant_pdp_title_i_sku"
  }, {
    path: "/en/wellcome/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "en_wellcome_pdp_title_i_sku"
  }, {
    path: "/en/p/:title/i/:sku.html",
    component: _6f7de986,
    name: "en_pdp_title_i_sku"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
